<template>
    <div>
        <div :class="{ 'mt-5': notHome }" class="container">

            <div class="row">
                <div class="col-12">

                    <!-- page title -->

                    <h2  v-if="routeName != 'home'" class="float-left mt-0 h3">{{ pageName }}</h2>

                    <span v-if="routeName == 'ministry'" class="mb-5 float-right text-right min_rss mt-4">
                        <img class="mt-0" id="rss" :src="$vueAssets + 'rssblack.png'" alt="rss icon">
                        <a :href="rssUrl" class="ml-2">{{ this.$t("page_rss") }}</a>
                    </span>
                    <div class="clearfix"></div>

                    <results :hasPagination=true :limit="10" ref="results"></results>
                </div>

            </div> <!-- row -->
        </div> <!-- container -->
    </div>
</template>

<script>
import Results from '../components/Results.vue'

export default {

  components: {
    Results
  },

  data () {
    return {
      routeName: this.$route.name,
      ministryName: null,
      activeMinistryAcronym: null,
      notHome: null,
      titleUpdatedFlag: 0
    }
  },
  // This is a function used by the vue-meta plugin
  metaInfo () {
    return {
      meta: [
        { vmid: 'keywords', name: 'keywords', content: (this.$route.meta.title ? this.$route.meta.title[this.currentLanguageAcronym] : this.ministryName) },
        { vmid: 'description', name: 'description', content: (this.$route.meta.title ? this.$route.meta.title[this.currentLanguageAcronym] : this.ministryName) }
      ]
    }
  },

  computed: {

    //Set page name
    pageName: function () {
      let contentName = ''
      //Check which route
      switch (this.routeName) {
        case "releases": {
          //News releases
          contentName = this.$t("page_releases")
          break
        }
        case "advisories": {
          //Media advisories
          contentName = this.$t("page_advisories")
          break
        }
        case "bulletins": {
          //Bulletings
          contentName = this.$t("page_bulletins")
          break
        }
        //Will need to emit this up from results component?
        case "ministry": {
          //Specific ministry
          contentName = this.ministryName
          break
        }
      }
      return contentName
    },

    rssUrl () {
      return window.location.origin + '/' + this.activeMinistryAcronym + '/' +this.$root.$i18n.locale + '/rss/news.rss'
    },

  },

  methods: {
    setEventListeners () {
      // Listen for the ministry name being emitted from the child component (results)
      this.$refs.results.$on('ministry-name', (recievedMinistryName, activeMinistryAcronym) => {
        // this event is triggered everytime the results component loads results for this route
        // To prevent this code from running everytime new results are fetched, it's been tied to a flag within this component

        if (this.titleUpdatedFlag == 0) {
          // Set parent instance of ministry name
          this.ministryName          = recievedMinistryName
          this.activeMinistryAcronym = activeMinistryAcronym

          this.updateUrl()
          this.updateSiteTitle(this.ministryName)
          this.fireGAEvent()
        }
        this.titleUpdatedFlag = 1
      })
    },

    // If ministry landing page, update url to have proper active acronym
    updateUrl () {
      history.replaceState(
        {},
        null,
        '/' + this.activeMinistryAcronym + '/' + this.$root.$i18n.locale + window.location.search
      )
    },
    // Update the site title to include the ministry name
    updateSiteTitle () {
      document.title = this.ministryName + ' | ' + document.title
    },
    fireGAEvent () {
      window.dataLayer.push({
        'event': 'Pageview',
        'pagePath': window.location.href,
        'pageTitle': document.title,
        'ministryOwner': (this.ministryName ? this.ministryName : undefined),
        'newsroomID': undefined,
        'contentType': undefined,
        'publishDate': undefined
      })
    }
  },

  mounted () {
    this.setEventListeners()
  }
}

</script>
